var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('EpbToggle',{class:`${_vm.baseClass}`,attrs:{"options":_vm.toggleOptions},on:{"input":newValue => _vm.$emit('input', newValue)},model:{value:(_vm.mode),callback:function ($$v) {_vm.mode=$$v},expression:"mode"}})
}
var staticRenderFns = []

export { render, staticRenderFns }